import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import {
  PlaybackService,
  PlayerController,
  SplixerLayoutControlService,
  StationManagerService,
  TimelineService,
} from '@splixer/player';
import { nString } from '@hidat/huijs-common';
import { MediaContentType } from '@splixer/common';
import { PV2PlayerComponent } from '@splixer/player-ui';

@Component({
  selector: 'knhc-player',
  templateUrl: 'player.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PV2PlayerComponent],
  standalone: true,
})
export class KnhcPlayerComponent extends PlayerController {
  public displayControls = input(false, { transform: booleanAttribute });
  public displayInfo = input(true, { transform: booleanAttribute });

  protected playback = inject(PlaybackService);
  protected layout = inject(SplixerLayoutControlService);
  protected timeline = inject(TimelineService);
  protected station = inject(StationManagerService);

  protected npName = computed(() => {
    let name: nString;
    if (this.playback.firstPlayStarted()) {
      const np = this.timeline.nowPlayingItem();
      if (np) {
        if (np.content) {
          if (np.content.contentType === MediaContentType.MicBreak) {
            name = 'Air Break';
          } else {
            name = np.content.name;
          }
        }
        if (!name) {
          name = np.mix?.name;
        }
        if (!name) {
          name = np.show?.name;
        }
        if (!name) {
          name = np.program?.name;
        }
      }
    } else {
      name = 'Please choose a show to listen to!';
    }
    return name;
  });

  protected npPerformer = computed(() => {
    const np = this.timeline.nowPlayingItem();
    let name: nString;
    if (np) {
      if (np.content) {
        name = np.content.performerName;
      }
    }
    return name;
  });
}
